module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pager"
  }, [_c('div', {
    staticClass: "container",
    staticStyle: {
      "border": "solid #e9e5e5",
      "border-radius": "3px",
      "background": "#ffffff"
    }
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "padding": "0 1em",
      "text-align": "left"
    }
  }, [_c('h5', [_vm._v(_vm._s(_vm.sellpoint.business_name) + "\r\n          "), _c('span', {
    staticStyle: {
      "float": "right",
      "font-size": "22px"
    }
  }, [(_vm.catvw) ? _c('a', {
    on: {
      "click": _vm.hide_cat
    }
  }, [_c('i', {
    staticClass: "fa fa-caret-down"
  })]) : _c('a', {
    on: {
      "click": _vm.show_cat
    }
  }, [_c('i', {
    staticClass: "fa fa-caret-down"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "p-cat",
    attrs: {
      "id": "cat-nav"
    }
  }, [_c('ul', _vm._l((_vm.sellpoint.business_categories), function(category) {
    return _c('li', [_c('a', {
      attrs: {
        "href": "#"
      }
    }, [_vm._v(_vm._s(category.business_category))])])
  }))])])]), _vm._v(" "), _c('div', {
    staticClass: "container",
    staticStyle: {
      "background": "#ffffff",
      "margin-bottom": "4em"
    }
  }, [_c('div', {}, _vm._l((_vm.products), function(product, index) {
    return _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticStyle: {
        "margin": "1em"
      }
    }, [_c('a', {
      staticStyle: {
        "text-decoration": "none",
        "color": "inherit"
      },
      attrs: {
        "href": '/' + _vm.sellpoint.business_username + '/' + product.product_url_name
      }
    }, [_c('div', {
      staticClass: "col-xs-3",
      staticStyle: {
        "height": "75px",
        "width": "25%",
        "padding": "0"
      }
    }, [(product.product_images[0]) ? _c('div', {
      staticStyle: {
        "height": "100%",
        "width": "80px",
        "background-position": "center",
        "background-size": "cover"
      },
      style: ({
        'background-image': 'url(' + product.product_images[0].product_image + ')'
      })
    }) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-9",
      staticStyle: {
        "width": "75%"
      }
    }, [_c('div', {
      staticClass: "card-arm-line"
    }, [_c('p', [_vm._v(_vm._s(product.product_name)), _c('br'), _vm._v(" "), (product.product_items[0]) ? _c('span', {
      staticStyle: {
        "font-size": "12px"
      }
    }, [_vm._v("₦" + _vm._s(product.product_items[0].product_item_price) + " \r\n                      "), _c('del', [_vm._v("₦" + _vm._s(product.product_items[0].product_item_price))])]) : _vm._e(), _c('br'), _vm._v(" "), _vm._m(0, true)])])])])])])
  }))])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "float": "left"
    }
  }, [_c('ul', {
    staticStyle: {
      "display": "inline",
      "color": "#ffd900",
      "margin": "0",
      "padding": "0"
    }
  }, [_c('li', [_c('i', {
    staticClass: "fa fa-star"
  })]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-star"
  })]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-star"
  })]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-star"
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-51ef2fe8"}!./src/pages/Sellpoint/Sellpoint/template.html
// module id = 260
// module chunks = 0